import React from 'react';
import { Link } from 'react-router-dom';
import { Search, Menu, User, Plus } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Sheet, SheetContent, SheetTrigger } from '../ui/sheet';
import { Logo } from '../Logo';
import { useApp } from '../../context/AppContext';
import { useAuth } from '../../context/AuthContext';
import { LANGUAGES } from '../../lib/i18n';

export const MobileMenu = ({ open, onOpenChange, navLinks, q, setQ, onSearch }) => {
  const { t, lang, setLang } = useApp();
  const { user, logout } = useAuth();
  const close = () => onOpenChange(false);
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetTrigger asChild>
        <button className="md:hidden ml-auto p-2 rounded-lg hover:bg-[#FAF7F2]" data-testid="mobile-menu-button" aria-label="menu"><Menu className="w-5 h-5" /></button>
      </SheetTrigger>
      <SheetContent side="right" className="w-80">
        <div className="flex flex-col gap-6 pt-6">
          <Logo />
          <form onSubmit={(e) => { onSearch(e); close(); }} className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#7A7468]" />
            <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder={t('hero.search')} className="pl-10 bg-[#FAF7F2]" data-testid="mobile-search-input" />
          </form>
          <nav className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <Link key={l.to} to={l.to} onClick={close} className="px-3 py-2.5 rounded-lg hover:bg-[#FAF7F2] font-medium" data-testid={`mobile-nav-${l.id}`}>{l.label}</Link>
            ))}
          </nav>
          <Link to="/post" onClick={close}><Button className="w-full bg-[#0F8B5C] hover:bg-[#0A6E47] text-white" data-testid="mobile-post-button"><Plus className="w-4 h-4 mr-2" /> {t('nav.post')}</Button></Link>
          <Link to="/signin" onClick={close}>{user
            ? <Button variant="outline" className="w-full" data-testid="mobile-logout-button" onClick={(e) => { e.preventDefault(); logout(); close(); }}><User className="w-4 h-4 mr-2" /> {t('auth.logout')} ({user.avatar})</Button>
            : <Button variant="outline" className="w-full" data-testid="mobile-signin-button"><User className="w-4 h-4 mr-2" /> {t('nav.signin')}</Button>}</Link>
          <div className="grid grid-cols-3 gap-2 pt-4 border-t">
            {LANGUAGES.map((l) => (
              <button key={l.code} onClick={() => setLang(l.code)} data-testid={`mobile-lang-${l.code}`} className={`p-2 rounded-lg text-sm font-medium ${lang === l.code ? 'bg-[#0F8B5C] text-white' : 'bg-[#FAF7F2]'}`}>{l.flag} {l.code.toUpperCase()}</button>
            ))}
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};
